import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { noNaN } from '../../../utils/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { shouldDebugGridActions } from './add';
import { TRowActionResponse } from './types';
import { getSelectedRowsForSortEvent } from './up';

const down = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
  },
  TDataGridThunkState
>('dataGridSlice/rowDown', async ({ gridId }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const rowId = getSelectedRowsForSortEvent(gridId);
  const sortedSelectedRows = state.selectedRows.sort();
  const currentPage = noNaN(state.context.grid.field.curPage);
  const pages = noNaN(state.context.grid.field.pages);
  const gridField = state.context.grid.field;
  const isPaged = gridField.properties.paged;
  const gridSize =
    isPaged && gridField.properties.pagedGridSize === undefined
      ? 5
      : Number(gridField.properties.pagedGridSize);
  const isLastSelected = [...sortedSelectedRows].pop() === gridSize - 1;

  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'down',
      context: state.context,
      rowId,
    }),
  );
  if (shouldDebugGridActions) console.log('down', result?.data);
  if (result?.data)
    return {
      focusRow:
        isLastSelected && currentPage !== pages ? 0 : state.focusedRow + 1,
      newSelectedRows:
        isLastSelected && currentPage !== pages
          ? [0]
          : state.selectedRows.map((current) => current + 1),
      xmlResponse: result?.data,
    };

  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default down;
